<template>
    <div class="group-item ellipsis mb20 tac" :class="active?'active':''" @click="changeGroup(group)">
        <p class="ellipsis">ID：{{group.group_id}} （{{group.total||0}}）</p>
        <p class="ellipsis" :title="group.group_name">{{group.group_name}}</p>
    </div>
</template>

<script>
    export default {
        name: "AdGroupItem",
        props:{
            active:Boolean,
            group:Object,
        },
        methods:{
            changeGroup(){
                if(this.active) return;
                this.$emit('change',this.group.group_id);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .group-item{
        padding: 5px 8px;
        width: 200px;
        border: solid 1px #DCDFE6;
        color: #606266;
        background-color: #fff;
        cursor: pointer;
        font-size: 12px;
        p{
            line-height: 16px;
            display: block;
        }
        &.active{
            color: #fff;
            background-color: #409EFF;
            border-color: #409EFF;
        }
    }
</style>
